import { render, staticRenderFns } from "./ShippingPhases.vue?vue&type=template&id=283b3389"
import script from "./ShippingPhases.vue?vue&type=script&lang=js"
export * from "./ShippingPhases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports